import { Backend } from '@/_axios';

export default {
  list(projectId, params) {
    return Backend.get(`/project/${projectId}/ai_jobs/`, { params });
  },
  createData(projectId) {
    return Backend.get(`/project/${projectId}/ai_jobs/create`);
  },
  editData(projectId, id) {
    return Backend.get(`/project/${projectId}/ai_jobs/${id}/edit`);
  },
  create(projectId, data) {
    return Backend.post(`/project/${projectId}/ai_jobs/`, data);
  },
  update(projectId, data) {
    return Backend.put(`/project/${projectId}/ai_jobs/${data.id}`, data);
  },
  delete(projectId, id) {
    return Backend.delete(`/project/${projectId}/ai_jobs/${id}`);
  },
};
